const breakpoints = {
  mobile: 320,
  mobileLandscape: 480,
  tablet: 768,
  tabletLandscape: 992,
  desktop: 1200,
  desktopLarge: 1440,
  desktopWide: 1920
}
const mediaQueries = {
  mobile: `@media (min-width: ${breakpoints.mobile}px)`,
  mobileLandscape: `@media (min-width: ${breakpoints.mobileLandscape}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  tabletLandscape: `@media (min-width: ${breakpoints.tabletLandscape}px)`,
  tabletDown: `@media (max-width: ${breakpoints.tabletLandscape}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  desktopLarge: `@media (min-width: ${breakpoints.desktopLarge}px)`,
  desktopWide: `@media (min-width: ${breakpoints.desktopWide}px)`
}

const media = (breakpoint, styles) => ({
  [mediaQueries[breakpoint]]: {
    ...styles
  }
})

media.breakpoints = breakpoints

export default media


// WEBPACK FOOTER //
// ./src/style/media.js